export default __webpack_public_path__ + "static/media/Trophy.558ecc9c.png";